var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnStarYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5034 10.8535C13.2929 11.064 13.1666 11.4008 13.2508 11.6955L13.9664 15.9055C14.0085 16.4528 13.6297 16.9158 13.1245 17C12.9561 17 12.7877 17 12.6193 16.9158L8.83033 14.9372C8.57774 14.7688 8.24094 14.7688 7.98835 14.9372L4.19941 16.8737C3.73631 17.1263 3.14692 16.9158 2.93643 16.4528C2.85223 16.2844 2.81013 16.0739 2.85223 15.8634L3.56792 11.6534C3.61002 11.3587 3.52582 11.0219 3.31532 10.8114L0.28417 7.8645C-0.0947235 7.4856 -0.0947235 6.93831 0.28417 6.55942C0.410468 6.43312 0.578866 6.30682 0.789362 6.30682L4.99929 5.67533C5.29399 5.63323 5.58868 5.42273 5.67288 5.17014L7.56735 1.3812C7.81995 0.918107 8.36724 0.74971 8.83033 0.960206C8.99873 1.0444 9.16713 1.2128 9.25133 1.3812L11.1458 5.17014C11.3142 5.42273 11.5247 5.63323 11.8194 5.67533L16.0293 6.30682C16.5345 6.39102 16.8713 6.89621 16.7871 7.4014C16.745 7.5698 16.6608 7.7382 16.5345 7.90659L13.5034 10.8535Z",
    fill: "#F6B93B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnStarYellow);
export default __webpack_public_path__ + "static/media/icn_star_yellow.4fb2df77908919140338ff37b2a2008c.svg";
export { ForwardRef as ReactComponent };